const teleDateFormat = (tele) => {
	try {
		const timestamp = new Date(tele);
		return timestamp.getHours() < 12 ? "Manhã" : "Tarde";
	} catch (error) {
		console.log(error);
	}
}

export default teleDateFormat